// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.margin-left-5{
  margin-left: 5px;
}
.add-img {
  display: none;
}

.send-otp{
  color: #7a5d00;
  cursor: pointer;
}

.pm-login-wrap {
  min-height: calc(100vh - 2rem);
}

.pm-login-card-wrap {
  max-width: 460px;
}

.pm-login-card {
  border: 1px solid #f0d56f;
  border-radius: 16px;
  background: linear-gradient(180deg, #fffef7 0%, #fdf8e4 100%);
  box-shadow: 0 18px 40px rgba(98, 77, 0, 0.12);
}

.brand-logo-login {
  max-height: 100px;
  width: auto;
  object-fit: contain;
  filter: drop-shadow(0 4px 10px rgba(98, 77, 0, 0.25));
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImxvZ2luLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxnQkFBZ0I7QUFDbEI7QUFDQTtFQUNFLGFBQWE7QUFDZjs7QUFFQTtFQUNFLGNBQWM7RUFDZCxlQUFlO0FBQ2pCOztBQUVBO0VBQ0UsOEJBQThCO0FBQ2hDOztBQUVBO0VBQ0UsZ0JBQWdCO0FBQ2xCOztBQUVBO0VBQ0UseUJBQXlCO0VBQ3pCLG1CQUFtQjtFQUNuQiw2REFBNkQ7RUFDN0QsNkNBQTZDO0FBQy9DOztBQUVBO0VBQ0UsaUJBQWlCO0VBQ2pCLFdBQVc7RUFDWCxtQkFBbUI7RUFDbkIscURBQXFEO0FBQ3ZEIiwiZmlsZSI6ImxvZ2luLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIubWFyZ2luLWxlZnQtNXtcbiAgbWFyZ2luLWxlZnQ6IDVweDtcbn1cbi5hZGQtaW1nIHtcbiAgZGlzcGxheTogbm9uZTtcbn1cblxuLnNlbmQtb3Rwe1xuICBjb2xvcjogIzdhNWQwMDtcbiAgY3Vyc29yOiBwb2ludGVyO1xufVxuXG4ucG0tbG9naW4td3JhcCB7XG4gIG1pbi1oZWlnaHQ6IGNhbGMoMTAwdmggLSAycmVtKTtcbn1cblxuLnBtLWxvZ2luLWNhcmQtd3JhcCB7XG4gIG1heC13aWR0aDogNDYwcHg7XG59XG5cbi5wbS1sb2dpbi1jYXJkIHtcbiAgYm9yZGVyOiAxcHggc29saWQgI2YwZDU2ZjtcbiAgYm9yZGVyLXJhZGl1czogMTZweDtcbiAgYmFja2dyb3VuZDogbGluZWFyLWdyYWRpZW50KDE4MGRlZywgI2ZmZmVmNyAwJSwgI2ZkZjhlNCAxMDAlKTtcbiAgYm94LXNoYWRvdzogMCAxOHB4IDQwcHggcmdiYSg5OCwgNzcsIDAsIDAuMTIpO1xufVxuXG4uYnJhbmQtbG9nby1sb2dpbiB7XG4gIG1heC1oZWlnaHQ6IDEwMHB4O1xuICB3aWR0aDogYXV0bztcbiAgb2JqZWN0LWZpdDogY29udGFpbjtcbiAgZmlsdGVyOiBkcm9wLXNoYWRvdygwIDRweCAxMHB4IHJnYmEoOTgsIDc3LCAwLCAwLjI1KSk7XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/login/login.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,6DAA6D;EAC7D,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA,gyCAAgyC","sourcesContent":[".margin-left-5{\n  margin-left: 5px;\n}\n.add-img {\n  display: none;\n}\n\n.send-otp{\n  color: #7a5d00;\n  cursor: pointer;\n}\n\n.pm-login-wrap {\n  min-height: calc(100vh - 2rem);\n}\n\n.pm-login-card-wrap {\n  max-width: 460px;\n}\n\n.pm-login-card {\n  border: 1px solid #f0d56f;\n  border-radius: 16px;\n  background: linear-gradient(180deg, #fffef7 0%, #fdf8e4 100%);\n  box-shadow: 0 18px 40px rgba(98, 77, 0, 0.12);\n}\n\n.brand-logo-login {\n  max-height: 100px;\n  width: auto;\n  object-fit: contain;\n  filter: drop-shadow(0 4px 10px rgba(98, 77, 0, 0.25));\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
